
import Vue from "vue"
// import Loading from '@/components/loading/index.vue'
import useLoading from "@/hooks/useLoading";
import { ELanguageType } from "@/plugins/i18n";
import { createMainScrollerControl, createToTopControl } from "@/mixins";
import Icon from "@/components/icon/index.vue"
useLoading()
export default Vue.extend({
	data() {
		return {
			loading: true,
			loading1: true,
			loading2: true,
		}
	},
	components: {
		Icon
	},
	mixins: [
		createToTopControl({
			refName: "aboutContainer",
		}),
		createMainScrollerControl({
			refName: "aboutContainer"
		})
	],
	computed: {
		isJp() {
			return this.$i18n.locale === 'jp'
		},
		arrowDown: () => "arrowDown",
	}
})
